"use strict";

exports.__esModule = true;
exports.GET_MY_OPTINS_SUCCESS = exports.ACCEPT_OPTIN_SUCCESS = void 0;
const GET_MY_OPTINS_SUCCESS = exports.GET_MY_OPTINS_SUCCESS = 'GET_MY_OPTINS_SUCCESS';
const ACCEPT_OPTIN_SUCCESS = exports.ACCEPT_OPTIN_SUCCESS = 'ACCEPT_OPTIN_SUCCESS';